import React from 'react';
import PropTypes from 'prop-types';
import "./aboutUs.css" 
AboutUs.propTypes = {
    
};

function AboutUs(props) {
    return (
        <div className="aboutus">
            <li>About us</li>
        </div>
    );
}

export default AboutUs;